module.exports = __webpack_public_path__ + "static/media/Rupa.1fd06ff2.jpg";